import React from "react";
import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";


// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import DashboardCard from "components/Cards/DashboardCard.jsx";


import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import priceImage1 from "assets/img/card-2.jpeg";
import priceImage2 from "assets/img/card-3.jpeg";
import priceImage3 from "assets/img/card-1.jpeg";



class Dashboard extends React.Component {
  state = {
    value: 0
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleChangeIndex = index => {
    this.setState({ value: index });
  };
  render() {
    const { history, translate } = this.props;
    return (
      <div>
        <GridContainer>
          <ItemGrid xs={12} sm={6} md={6} lg={6}>
            <DashboardCard
              image={priceImage1}
              title={translate("layout.dashboard.title1")}
              text={translate("layout.dashboard.text1")}
              onClick={() => history.push('/receiver/application') } 
              buttonText={translate("layout.dashboard.buttonText1")}
            />          
          </ItemGrid>
          <ItemGrid xs={12} sm={6} md={6} lg={6}>
            <DashboardCard
              image={priceImage2}
              title={translate("layout.dashboard.title2")}
              text={translate("layout.dashboard.text2")}
              onClick={() => history.push('/customer/application') } 
              buttonText={translate("layout.dashboard.buttonText2")}
            />             
          </ItemGrid>
        </GridContainer>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};


const mapDispatchToProps = {
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
  }
}

export default compose(
  withStyles(dashboardStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx